/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'park': {
    width: 110,
    height: 97,
    viewBox: '0 0 110 97',
    data: '<path pid="0" d="M110 92.014V96.6H0v-4.586h34.47V80.668H12.24l11.688-26.03H12.24L36.76 0l24.52 54.637h-11.69l11.69 26.03h-22.23v11.347h34.677l15.831-54.98 15.818 54.98H110z" _fill="#2B363B"/><path pid="1" d="M75.76 24.431c6.075 0 10.996-4.948 10.996-11.024 0-6.07-4.928-11.024-10.997-11.024-6.096 0-11.024 4.948-11.024 11.024.007 6.076 4.935 11.024 11.024 11.024z" _fill="#2B363B"/>'
  }
})
